import { ChakraButton as Button, ChakraFlex as Flex } from "@airhelp/react-ui-components";
import { useLanguage } from "contexts/LocalizationContext";
import { getPageUrl } from "utils/getPageUrl";
import { trackClickEvent } from "utils/trackingUtils";

const ItemUseBoardingPass = () => {
  const language = useLanguage();

  return (
    <Flex gap={3} direction={{ base: "column", md: "row" }}>
      <Button
        size="m"
        as="a"
        href={getPageUrl(language, "webappBarcodeUploader")}
        title="Upload File"
        onClick={() => trackClickEvent("Hero", "CheckYourCompensationUploader")}
      >
        Upload File
      </Button>
      <Button
        size="m"
        h="48px"
        as="a"
        variant="secondary"
        href={getPageUrl(language, "webappBarcodeScanner")}
        title="Use Your Camera"
        onClick={() => trackClickEvent("Hero", "CheckYourCompensationBarcode")}
      >
        Use Your Camera
      </Button>
    </Flex>
  );
};

export default ItemUseBoardingPass;
